import _debounce from "lodash/debounce";

(function($) {
    $('.modalAttachable').each(function() {
        const me = $(this);
        const form = me.find('form');
        const selectedItems = new Set();
        const selectedItemsHiddenInput = form.find('input[name="selectedItems"]').first();
        const assignTbody = form.find('tbody.attachable-tbody').first();
        const query = form.find('input[name="query"]').first();
        me.on('show.bs.modal', function () {
            getAttachables('')
        });

        form.on('change', 'input[type="checkbox"]', function () {
            const me = $(this);
            if (me.is(':checked')) {
                selectedItems.add(me.val());
            } else {
                selectedItems.delete(me.val());
            }
            selectedItemsHiddenInput.val(Array.from(selectedItems).join(','))
        });

        query.on('keyup', _debounce(function() {
            getAttachables($(this).val());
        }, 200))

        function getAttachables(searching) {
            let url = me.attr('data-url');
            let page = 1;

            window.axios.get(url, {params: {
                    page: page,
                    search: searching,
                }}).then(({data}) => {
                assignTbody.html('');
                let dataList = data.data;
                $.each(dataList, function (key, item) {
                    if (selectedItems.has(String(item.id))) {
                        assignTbody.append(
                            `<tr>
                    <td>${item.title}</td>
                    <td>${item.description}</td>
                    <td>
                        <label class="is-form-check">
                            <input class="is-form-check--input"
                                value="${item.id}"
                                checked
                                type="checkbox">
                            <span class="is-form-check--input--checkmark"></span>
                        </label>
                    </td>
                </tr>`
                        );
                    } else {
                        assignTbody.append(
                            `<tr>
                    <td>${item.title}</td>
                    <td>${item.description}</td>
                    <td>
                        <label class="is-form-check">
                            <input class="is-form-check--input"
                                value="${item.id}"
                                type="checkbox">
                            <span class="is-form-check--input--checkmark"></span>
                        </label>
                    </td>
                </tr>`
                        );
                    }
                });
            })
        }

    });

})(jQuery);
